import SummaryRest from 'utils/SummaryRest';
import { createAction } from 'redux-actions';
import { PAGE_TYPE_CONVERT } from 'utils/constants';
import moment from 'moment';
import {
  CHANGE_TREND_TAG,
  CHANGE_RANK_TAG,
  CHANGE_PAGE_TYPE,
  CHANGE_TREND_PARAMS,
  CHANGE_TOP3_STATUS,
  CHANGE_DATA_TYPE,
  CHANGE_TOPISSUEDATA_TYPE,
  CHANGE_SUMMARY_VM_SELECT_VALUE,
} from 'store/actions';
import { ProductSummaryUtil } from 'components/exception/ProductSummaryPage/ProductSummaryUtil';
import { getStartEndDateFromStr } from 'utils/StringUtils';
import { CountryUtil } from 'utils/country';
import { isNotNullish, isNullish } from 'utils/nullish';
import { CsvUtil } from 'utils/csv-util';
import { VersionUtil } from 'utils/version-util';
import { ReduxActionType } from 'reducers/redux-action-type';
import { VmTypeUtil } from 'utils/constants/vm-type';
import { ExceptionCategoryUtil } from 'utils/exception-category';
import { isIos } from 'utils/platform';
import { FieldName, QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { IssueAggregateType } from 'utils/constants/issue-aggregate-type';
import { TopIssueJankType } from 'utils/constants/top-issue-jank-type';
import { TopIssueCompareType, TopIssueUtils } from 'components/exception/ProductSummaryPage/TopIssueList/TopIssueList';
import { TopIssueWangZheExpNameType } from 'utils/constants/top-issue-wang-zhe-exp-name-type';
import {fromJS} from 'immutable';
import { DashboardConst } from 'utils/constants/dashboard-const';
import {BillingTeamType} from 'utils/constants/billing';
import {ServerAppSettings} from 'utils/server-app-settings';

const TAG = '[summaryActions]::';

export const systemAccess = getTopData(SummaryRest.system.access,'system-access', 'osVersion');
export const systemRate = getTopData(SummaryRest.system.rate,'system-rate', 'osVersion');

export const modelAccess = getTopData(SummaryRest.model.access,'model-access', 'model');
export const modelRate = getTopData(SummaryRest.model.rate,'model-rate', 'model');

export const appAccess = getTopData(SummaryRest.app.access,'app-access', 'version');
export const appRate = getTopData(SummaryRest.app.rate,'app-rate', 'version');

export const gpuAccess = getTopData(SummaryRest.gpu.access, 'gpu-access', 'gpu');
export const gpuRate = getTopData(SummaryRest.gpu.rate, 'gpu-rate', 'gpu');

export const cpuAccess = getTopData(SummaryRest.cpu.access, 'cpu-access', 'cpu');
export const cpuRate = getTopData(SummaryRest.cpu.rate, 'cpu-rate', 'cpu');

export const gpuDriverVersionAccess = getTopData(SummaryRest.gpuDriverVersion.access, 'gpuDriverVersion-access', 'gpuDriverVersion');
export const gpuDriverVersionRate = getTopData(SummaryRest.gpuDriverVersion.rate, 'gpuDriverVersion-rate', 'gpuDriverVersion');

export const tagAccess = getTopData(SummaryRest.tag.access, 'tag-access', 'tag');
export const tagRate = getTopData(SummaryRest.tag.rate, 'tag-rate', 'tag');

export function fetchCountryGroupConfig() {
  return (dispatch, getState) => {
    const { appId } = getState().app.get('current').toJS();
    return dispatch({
      rest: SummaryRest.countryGroupConfig.fetch,
      data: { appId },
    });
  };
}

export function fetchSdkIntegratedApps(sdkAppId) {
  return (dispatch, getState) => {
    const { appId } = getState().app.get('current').toJS();
    return dispatch({
      rest: SummaryRest.fetchSdkIntegratedApps.fetch,
      data: {
        appId,
        sdkAppId,
      },
    });
  };
}

export function fetchSdkIntegratedAppVersions(sdkAppId, integratedAppId) {
  return (dispatch, getState) => {
    const { appId } = getState().app.get('current').toJS();
    return dispatch({
      rest: SummaryRest.fetchSdkIntegratedAppVersions.fetch,
      data: {
        appId,
        sdkAppId,
        integratedAppId,
      },
    });
  };
}

export function queryBigDataLastUpdateTime() {
  return async (dispatch, getState) => {
    const { appId } = getState().app.get('current').toJS();
    const rsp = await RestHelper.mustPost('/redir/api/statResource/queryBigDataLastUpdateTime', {appId});
    const { realtimeUpdateMillis: bigDataRealtimeUpdateMillis, resultDailyUpdateMillis: bigDataResultDailyUpdateMillis } = rsp.json.data;
    return dispatch({
      type: ReduxActionType.patchSummaryState,
      payload: { bigDataRealtimeUpdateMillis, bigDataResultDailyUpdateMillis },
    });
  };
}

/**
 * 获取top issue数据
 */
export function getTopIssue(extraDataMap = {}) {
  return async (dispatch, getState) => {
    const { appId, platformId } = getState().app.get('current').toJS();
    const {
      subModuleId,
      topIssueVersion,
      topIssueDate,
      topIssueMaxDate,
      topIssueCountry,
      // topIssueSubModuleId,
      topIssueFilterRawSearchJsonStr,
      topIssueEnableFilter,
      topIssueEnableCrashFilter,
      topIssueCrashFilterScgStr,
      topIssueIntegratedAppId,
      topIssueVmSelectValue,
      topIssueSortField,
      topIssueJankType,
      topIssueMinDeviceCount,
      topIssueMinJankTime,
      topIssueWangZheExpNameType,
      topIssueCompareDate,
      topIssueUserSceneTag,
      isQueryVital,
    } = getState().summary.get('searchParams').toJS();
    const { pageType } = getState().summary.get('selectOptions').toJS();
    // isMetricKit 只用于本地做 type 转换，不透传给后端（TopRequestBean 没有对应字段）
    const { isMetricKit, isAexit, ...restExtraDataMap } = extraDataMap;
    let type = PAGE_TYPE_CONVERT[pageType];
    // isAexit 必须排在 isQueryVital 前面：isQueryVital 来自全局 searchParams，在退出信息页上同样为真，
    // 排在后面会让 aexit_crash 永远命中不到，TOP 退回普通崩溃（vital 查的是 crash+ANR 合集）。
    if (isAexit && ExceptionCategoryUtil.isAnr(type)) {
      type = 'aexit_anr';
    } else if (isAexit && ExceptionCategoryUtil.isCrash(type)) {
      type = 'aexit_crash';
    } else if (isQueryVital && ExceptionCategoryUtil.isCrash(type)) {
      type = PAGE_TYPE_CONVERT.vital;
    } else if (isMetricKit && ExceptionCategoryUtil.isCrash(type)) {
      // MetricKit 概览页“崩溃”tab 复用同一套 pageType='CRASH'，但 TOP 问题底表用的是独立的
      // metrickit_crash 类型（与异常概览页的普通崩溃 TOP 完全是两张表），必须靠调用方显式传入的
      // isMetricKit 区分，不能像趋势图那样只用 pageType 推导。
      type = 'metrickit_crash';
    }
    const issueFilterRawSearch = Number(topIssueEnableFilter) && topIssueFilterRawSearchJsonStr
      ? JSON.parse(topIssueFilterRawSearchJsonStr)
      : undefined;
    const crashFilter = Number(topIssueEnableCrashFilter) && topIssueCrashFilterScgStr
      ? JSON.parse(topIssueCrashFilterScgStr)
      : undefined;
    const isJankCategory = ExceptionCategoryUtil.isJank(pageType);

    dispatch({ type: 'UPDATE_SUMMARY_SEARCH_PARAMS', payload: { topIssueLoading: true } });

    const versionList = VersionUtil.makeVersionListFromVersionCsvString(topIssueVersion);
    const isMultiVersion = VersionUtil.isMultipleVersions(versionList);

    const minDate = topIssueDate;
    const maxDate = topIssueMaxDate || topIssueDate;

    if (isNotNullish(extraDataMap?.mergedJankIssueIdList) && extraDataMap.mergedJankIssueIdList.length !== 1) {
      message.error('Cannot set multiple or empty mergedJankIssueIdList');
      console.error('Cannot set multiple or empty mergedJankIssueIdList');
      return;
    }
    const isQuerySubJankIssues = isNotNullish(extraDataMap?.mergedJankIssueIdList);

    const {
      compareType: topIssueCompareType,
      customDateStr: topIssueCustomCompareDateStr,
    } = TopIssueUtils.parseTopIssueCompareDateStr(topIssueCompareDate, TopIssueCompareType.PREV_DAY);

    let inExpNameList = undefined;
    let excludeExpName = undefined;
    if (Number(topIssueWangZheExpNameType) === TopIssueWangZheExpNameType.IN_BATTLE) {
      inExpNameList = TopIssueUtils.getWangZheInBattleExpNameList();
      excludeExpName = false;
    } else if (Number(topIssueWangZheExpNameType) === TopIssueWangZheExpNameType.OUT_BATTLE) {
      inExpNameList = TopIssueUtils.getWangZheInBattleExpNameList();
      excludeExpName = true;
    }

    let rsp;
    try {
      rsp = await RestHelper.mustPost('/api/app/getTopIssue', {
        appId: (topIssueIntegratedAppId && topIssueIntegratedAppId !== '-1')
          ? `${appId}:${topIssueIntegratedAppId}`
          : appId,
        platformId,
        sortField: topIssueSortField,
        mergeMultipleVersionsWithInaccurateResult: isMultiVersion,
        version: isMultiVersion ? undefined : versionList[0],
        versionList: isMultiVersion ? versionList : undefined,
        type,
        minDate,
        maxDate,
        mergeMultipleDatesWithInaccurateResult: minDate !== maxDate,
        limit: 20,
        countryList: CountryUtil.queryStringToList(topIssueCountry),
        userSceneTagList: (topIssueUserSceneTag || '').split(',').filter(x => x).length > 0
          ? (topIssueUserSceneTag || '').split(',').filter(x => x)
          : undefined,
        vmTypeList: VmTypeUtil.vmSelectValueToVmTypeList(topIssueVmSelectValue),
        subModuleId,
        issueFilterRawSearch,
        crashFilter,
        jankType: (isJankCategory && topIssueJankType !== TopIssueJankType.MERGED_ISSUE) ? topIssueJankType : undefined,
        queryMergedJankIssue: (isJankCategory && topIssueJankType === TopIssueJankType.MERGED_ISSUE) ? true : undefined,
        minDeviceCount: isJankCategory ? topIssueMinDeviceCount : undefined,
        minJankTime: isJankCategory ? topIssueMinJankTime : undefined,
        inExpNameList,
        excludeExpName,
        customCompareDate: topIssueCompareType === TopIssueCompareType.CUSTOM ? topIssueCustomCompareDateStr : undefined,
        ...restExtraDataMap,
      });
      if (!isQuerySubJankIssues) {
        dispatch({type: 'summaryReducerSetTopIssueData', payload: rsp.json.data});
        dispatch({type: 'summaryReducerClearMergedIssueIdToSubJankTopIssueData' });
      } else {
        dispatch({
          type: 'summaryReducerPatchMergedIssueIdToSubJankTopIssueData',
          issueId: extraDataMap.mergedJankIssueIdList[0],
          payload: rsp.json.data,
        });
      }
    } catch(e) {
      dispatch({ type: 'summaryReducerSetTopIssueData', payload: {} });
    } finally {
      dispatch({ type: 'UPDATE_SUMMARY_SEARCH_PARAMS', payload: { topIssueLoading: false } });
    }

    // 王者卡顿定制需求，额外拉取问题的自定义kv：TopForm分布情况
    const issueIdList = (rsp?.json?.data?.topIssueList || []).map(x => x.issueId);
    if (isJankCategory && issueIdList.length > 0) {
      const rsp = await RestHelper.mustPost('/api/issue/queryIssueAggregate', {
        appId,
        searchConditionGroup: {
          conditions: [{
            field: FieldName.crashUploadTime,
            queryType: QueryType.RANGE,
            gte: moment(minDate, 'YYYYMMDD').valueOf(),
            lt: moment(maxDate, 'YYYYMMDD').add(1, 'days').valueOf(),
          }, {
            field: FieldName.issueId,
            queryType: QueryType.TERMS,
            terms: issueIdList,
          }],
        },
        customFields: [{
          aggregateType: IssueAggregateType.MULTI_TERMS,
          name: 'crashIssueId',
          subTerm: 'hashKeyValues.dgfGbgRrbDOPvvCPX00J2A==.originValue', // C03_K#TopForm
          termsSizeLimit: 100,
        }],
      });
      dispatch({ type: ReduxActionType.parseAggResultAndSetIssueIdToWangZheTopFormList, payload: rsp });
    }
  };
}

export function fetchRealTimeTopIssueAndSetState({ realTimeTopIssueSortField, realTimeTopIssueHour, realTimeTopIssueVersion, realTimeTopIssueCountry, realTimeTopIssueLimit, realTimeTopIssueVmSelectValue, realTimeTopIssueCompareDate, realTimeTopIssueUserSceneTag: realTimeTopIssueUserSceneTagArg } = {}, collapseTopIssues, isMetricKit, isAexit) {
  return (dispatch, getState) => {
    const { appId, platformId } = getState().app.get('current').toJS();
    const { searchParams } = getState().summary.toJS();
    const newVersion = realTimeTopIssueVersion || searchParams.realTimeTopIssueVersion;
    const newCountry = realTimeTopIssueCountry || searchParams.realTimeTopIssueCountry;
    const isQueryVital = searchParams.isQueryVital;
    const subModuleId = searchParams.subModuleId;
    // const newSubModuleId = subModuleId || searchParams.realTimeTopIssueSubModuleId;
    const { pageType } = getState().summary.get('selectOptions').toJS();
    let type = PAGE_TYPE_CONVERT[pageType];
    // isAexit 必须排在 isQueryVital 前面：isQueryVital 来自全局 searchParams，在退出信息页上同样为真，
    // 排在后面会让 aexit_crash 永远命中不到，TOP 退回普通崩溃（vital 查的是 crash+ANR 合集）。
    if (isAexit && ExceptionCategoryUtil.isAnr(type)) {
      type = 'aexit_anr';
    } else if (isAexit && ExceptionCategoryUtil.isCrash(type)) {
      type = 'aexit_crash';
    } else if (isQueryVital && ExceptionCategoryUtil.isCrash(type)) {
      type = PAGE_TYPE_CONVERT.vital;
    } else if (isMetricKit && ExceptionCategoryUtil.isCrash(type)) {
      // 见 getTopIssue 里的同名注释：MetricKit 概览页“崩溃”tab 的小时级 TOP 问题需要查询独立的
      // metrickit_crash 类型，靠调用方显式传入的 isMetricKit 与异常概览页的普通崩溃 TOP 区分开。
      type = 'metrickit_crash';
    }
    const newHour = realTimeTopIssueHour || searchParams.realTimeTopIssueHour;
    const newLimit = realTimeTopIssueLimit || searchParams.realTimeTopIssueLimit;
    const newSortField = realTimeTopIssueSortField || searchParams.realTimeTopIssueSortField;
    const newVmSelectValue = isNotNullish(realTimeTopIssueVmSelectValue) ? realTimeTopIssueVmSelectValue : searchParams.realTimeTopIssueVmSelectValue;
    const newRealTimeTopIssueCompareDate = realTimeTopIssueCompareDate || searchParams.realTimeTopIssueCompareDate;

    const {
      realTimeTopIssueEnableCrashFilter,
      realTimeTopIssueCrashFilterScgStr,
      realTimeTopIssueUserSceneTag,
    } = searchParams;
    const sceneTag = realTimeTopIssueUserSceneTagArg !== undefined
      ? realTimeTopIssueUserSceneTagArg
      : realTimeTopIssueUserSceneTag;
    const crashFilter = Number(realTimeTopIssueEnableCrashFilter) && realTimeTopIssueCrashFilterScgStr
      ? JSON.parse(realTimeTopIssueCrashFilterScgStr)
      : undefined;
    const realTimeUserSceneTagList = String(sceneTag || '').split(',').filter(x => x);

    dispatch({
      type: 'UPDATE_SUMMARY_SEARCH_PARAMS',
      payload: {
        realTimeTopIssueLoading: true,
        realTimeTopIssueSortField: newSortField,
        realTimeTopIssueVersion: newVersion,
        realTimeTopIssueCountry: newCountry,
        // realTimeTopIssueSubModuleId: newSubModuleId,
        realTimeTopIssueHour: newHour,
        realTimeTopIssueLimit: newLimit,
        realTimeTopIssueVmSelectValue: newVmSelectValue,
        realTimeTopIssueCompareDate: newRealTimeTopIssueCompareDate,
        ...(realTimeTopIssueUserSceneTagArg !== undefined
          ? { realTimeTopIssueUserSceneTag: realTimeTopIssueUserSceneTagArg }
          : {}),
      },
    });

    const {
      compareType: topIssueCompareType,
      customDateStr: topIssueCustomCompareDateStr,
    } = TopIssueUtils.parseTopIssueCompareDateStr(newRealTimeTopIssueCompareDate, TopIssueCompareType.PREV_HOUR);

    if (collapseTopIssues) {
      dispatch({
        type: 'CHANGE_TOP3_STATUS',
        payload: true,
      });
    }

    const versionList = VersionUtil.makeVersionListFromVersionCsvString(newVersion);
    const isMultiVersion = VersionUtil.isMultipleVersions(versionList);
    const serverAppSettings = getState().app.get('appIdToServerAppSettings')?.[appId] || {};
    const enableTenMinuteTrend = !!serverAppSettings[ServerAppSettings.keys.enableTenMinuteTrend];
    const effectiveGranularity = searchParams.realTimeGranularity || (enableTenMinuteTrend ? '10m' : '1h');
    const isTenMinMode = !isMetricKit && !isAexit && enableTenMinuteTrend && effectiveGranularity === '10m';
    let effectiveStartHour = newHour;
    if (isTenMinMode && effectiveStartHour && String(effectiveStartHour).length === 10) {
      effectiveStartHour = `${effectiveStartHour}00`;
    } else if (!isTenMinMode && effectiveStartHour && String(effectiveStartHour).length === 12) {
      effectiveStartHour = String(effectiveStartHour).slice(0, 10);
    }
    const isTenMin = isTenMinMode || (effectiveStartHour && String(effectiveStartHour).length === 12);
    if (effectiveStartHour !== newHour) {
      dispatch({
        type: 'UPDATE_SUMMARY_SEARCH_PARAMS',
        payload: { realTimeTopIssueHour: effectiveStartHour },
      });
    }

    return dispatch({
      rest: SummaryRest.realTimeTopIssue.fetch,
      data: {
        appId,
        platformId,
        sortField: newSortField,
        mergeMultipleVersionsWithInaccurateResult: isMultiVersion,
        version: isMultiVersion ? undefined : versionList[0],
        versionList: isMultiVersion ? versionList : undefined,
        countryList: CountryUtil.queryStringToList(newCountry),
        userSceneTagList: realTimeUserSceneTagList.length > 0 ? realTimeUserSceneTagList : undefined,
        subModuleId,
        startHour: effectiveStartHour,
        type,
        vmTypeList: VmTypeUtil.vmSelectValueToVmTypeList(newVmSelectValue),
        customCompareDate: topIssueCompareType === TopIssueCompareType.CUSTOM ? topIssueCustomCompareDateStr : undefined,
        limit: newLimit,
        crashFilter,
        ...(isTenMin ? { tenMin: true } : {}),
      },
    });
  };
}

/**
 * 把 AEXIT 聚合次数/设备覆盖到趋势序列的 crashNum/crashUser 上。
 * 联网/启动仍走普通趋势接口，避免 AEXIT 误查 result_metric_*。
 */
export function overlayAexitCrashOnTrend({ hourly = [], daily = [], bucket = 'crash' } = {}) {
  return (dispatch, getState) => {
    const pick = (row) => {
      if (bucket === 'all') {
        return {
          num: (row.crash || 0) + (row.anr || 0) + (row.lmk || 0) + (row.other || 0),
          devices: (row.crashDevice || 0) + (row.anrDevice || 0) + (row.lmkDevice || 0) + (row.otherDevice || 0),
        };
      }
      return {
        num: Number(row[bucket]) || 0,
        devices: Number(row[`${bucket}Device`]) || 0,
      };
    };
    const hourlyMap = {};
    (hourly || []).forEach((row) => {
      if (!row || !row.time) {
        return;
      }
      hourlyMap[moment(row.time).format('YYYYMMDDHH')] = pick(row);
    });
    const dailyMap = {};
    (daily || []).forEach((row) => {
      if (!row || !row.date) {
        return;
      }
      dailyMap[String(row.date).replace(/-/g, '')] = pick(row);
    });

    const mergeOrSynthesize = (current, map, synthesizeRows, keyFn) => {
      const list = (current && current.toJS) ? current.toJS() : (current || []);
      if (list.length > 0) {
        return list.map((item) => {
          const picked = map[item.date] || { num: 0, devices: 0 };
          return {
            ...item,
            crashNum: picked.num,
            crashUser: picked.devices,
          };
        });
      }
      return (synthesizeRows || []).map((row) => {
        const picked = pick(row);
        return {
          date: keyFn(row),
          crashNum: picked.num,
          crashUser: picked.devices,
          crashSession: 0,
          accessNum: 0,
          accessUser: 0,
        };
      }).filter(item => item.date);
    };

    const summary = getState().summary;
    return dispatch({
      type: ReduxActionType.patchSummaryState,
      payload: {
        realTimeTrendData: fromJS(mergeOrSynthesize(
          summary.get('realTimeTrendData'),
          hourlyMap,
          hourly,
          row => moment(row.time).format('YYYYMMDDHH'),
        )),
        trendData: fromJS(mergeOrSynthesize(
          summary.get('trendData'),
          dailyMap,
          daily,
          row => String(row.date).replace(/-/g, ''),
        )),
      },
    });
  };
}

/**
 * @param {{ isMetricKit?: boolean }} [options] - 透传到后端的可选参数。
 *   isMetricKit=true 时查询 MetricKit 聚合表数据，用于 MetricKit 分析页面。
 */
export function actionFetchDailySummary(options = {}) {
  const { isMetricKit = false, isAexit = false } = options;
  return async (dispatch, getState) => {
    const { appId, platformId, teamType, appName } = getState().app.get('current').toJS();
    const serverAppSettings = getState().app.get('appIdToServerAppSettings')[appId] || {};
    const isEnableSubModuleId = !!serverAppSettings[ServerAppSettings.keys.enableSubModuleId];
    const { subModuleId } = getState().summary.get('searchParams').toJS();
    const date = moment().format('YYYYMMDD');
    const startHour = `${date}00`;
    const endHour = `${date}23`;

    // 王者定制需求，如果项目开启了subModuleId，则头部的卡顿指标固定只展示局外指标'LobbyProfilerEnable'，不随subModuleId变化而改变。 --story=129624165 【CS】【P0】【王者】top问题、搜索支持按照卡顿时长过滤。大盘头部卡顿指标固定展示局外指标（不随发行渠道字段切换而改变）
    const isWangZhe = teamType === BillingTeamType.TENCENT && appName?.startsWith('王者');
    const wangZheFixedJankSubModuleId = 'LobbyProfilerEnable';

    const tasks = [];
    // 注意：后端字段名是 `metricKit`（不带 is 前缀），这是 Lombok+Jackson 兼容的设计选择，
    // 见 GetSummaryRequest.java 注释。这里参数名 `isMetricKit` 保留，仅 JSON key 转成 `metricKit`。
    tasks.push(RestHelper.mustPost('/api/app/fetchDailySummary', {
      appId,
      platformId,
      startHour,
      endHour,
      version: '-1',
      subModuleId,
      queryAllVmTypes: true,
      metricKit: isMetricKit,
      aexit: isAexit,
    }));
    if (isWangZhe && isEnableSubModuleId) {
      tasks.push(RestHelper.mustPost('/api/app/fetchDailySummary', {
        appId,
        platformId,
        startHour,
        endHour,
        version: '-1',
        subModuleId: wangZheFixedJankSubModuleId,
        queryAllVmTypes: true,
        metricKit: isMetricKit,
        aexit: isAexit,
      }));
    }
    const [rsp1, rsp2] = await Promise.all(tasks);
    const summaryData = rsp1.json.ret.data?.[0];
    let wangZheJankSummaryData = undefined;
    if (rsp2) {
      wangZheJankSummaryData = rsp2.json.ret.data?.[0];
    }
    dispatch({
      type: ReduxActionType.patchSummaryState,
      payload: {
        realTimeAppendData: fromJS(summaryData),
        wangZheJankSummaryData,
      },
    });
  };
}


// 改变趋势图的tag
export const changeTrendTag = createAction(CHANGE_TREND_TAG);

// 改变崩溃排行的tag
export const changeSummaryRankTag = createAction(CHANGE_RANK_TAG);

// 改变概览类型
export const changePageType = createAction(CHANGE_PAGE_TYPE);

// 改变趋势的搜索条件
export const changeTrendParams = createAction(CHANGE_TREND_PARAMS);

// 改变top3展示状态
export const changeTop3Status = createAction(CHANGE_TOP3_STATUS);

// 实时或累计状态
export const changeDataType = createAction(CHANGE_DATA_TYPE);

// topIssue显示数据类型状态
export const changeTopIssueDataType = createAction(CHANGE_TOPISSUEDATA_TYPE);

export const changeSummaryVmSelectValue = createAction(CHANGE_SUMMARY_VM_SELECT_VALUE);

export const updateSummarySearchParams = createAction('UPDATE_SUMMARY_SEARCH_PARAMS');

export const updateSummarySelectOptions = createAction('updateSummarySelectOptions');

/**
 * 拉取 userSceneTag 选项列表，内置 cooldown 防重复请求。
 * 同时支持多实例并发安全：先同步写入 lastFetchedMillis，后续并发 dispatch 会被 cooldown 拦截。
 * @param {number} cooldownMillis 冷却时间（毫秒），默认 60000
 */
export function actionFetchUserSceneTagOptions(cooldownMillis = 60000) {
  return async (dispatch, getState) => {
    const state = getState();
    const appId = state.app.getIn(['current', 'appId']);
    const platformId = state.app.getIn(['current', 'platformId']);
    if (!appId) {
      return;
    }
    const lastFetchedMillis = state.summary.getIn(['selectOptions', 'userSceneTag', 'lastFetchedMillis']) ?? 0;
    if (Date.now() - lastFetchedMillis < cooldownMillis) {
      return;
    }
    const fetchStartMillis = Date.now();
    // 乐观写入 lastFetchedMillis，阻断并发实例的重复 dispatch
    dispatch(updateSummarySelectOptions({
      userSceneTag: fromJS({ options: [], lastFetchedMillis: fetchStartMillis, isFetching: true }),
    }));
    let options = [];
    try {
      const rsp = await RestHelper.post('/redir/api/statResource/getUserSceneTagOptions', { appId, platformId });
      options = (rsp.json.data || [])
        .filter(x => x.value !== DashboardConst.USER_SCENE_TAG_ALL && x.value !== DashboardConst.USER_SCENE_TAG_TOTAL_OF_ALL_TAGS)
        .sort((a, b) => a.value?.localeCompare(b.value));
    } finally {
      dispatch(updateSummarySelectOptions({
        userSceneTag: fromJS({ options, lastFetchedMillis: fetchStartMillis, isFetching: false }),
      }));
    }
  };
}

export const setCountryGroupConfigModalVisible = createAction('SET_COUNTRY_GROUP_CONFIG_MODAL_VISIBLE');

/**
  * 查询趋势数据或者比较数据, 通过isTrend来区分.
  * 通过判断是否isRealTime来分别调用getRealTimeHourlyData和getTrendData
 * @param params {{ trend: boolean, compare: boolean, prevDay: boolean, prevWeek: boolean, isMetricKit: boolean }}
  *   isMetricKit=true 时查询 MetricKit 聚合表数据，用于 MetricKit 分析页面。
  */
export function getTrendOrCompareData(params) {
  let {
    trend = false,
    compare = false,
    prevDay,
    prevWeek,
    isMetricKit = false,
    isAexit = false,
  } = params || {};

  return (dispatch, getState) => {
    const isRealTime = getState().summary.get('searchParams').get('isRealTime');
    const dataType = getState().summary.get('searchParams').get('dataType');
    if (parseInt(isRealTime) === 1 && dataType === 'appendly') {
      return dispatch(getTrendOrCompareDataAppend(params));
    }
    if (isNullish(prevDay)) {
      prevDay = getState().summary.get('searchParams').get('enableRealtimePrevDayTrend');
    }
    if (isNullish(prevWeek)) {
      prevWeek = getState().summary.get('searchParams').get('enableRealtimePrevWeekTrend');
    }

    if (parseInt(isRealTime)) {
      const promises = [];
      trend && promises.push(dispatch(getRealTimeHourlyData('realTimeTrendData', false, isMetricKit, isAexit)));
      compare && promises.push(dispatch(getRealTimeHourlyData('realTimeCompareData', false, isMetricKit, isAexit)));
      prevDay && promises.push(dispatch(getRealTimeHourlyData('realTimePrevDayTrendData', false, isMetricKit, isAexit)));
      prevWeek && promises.push(dispatch(getRealTimeHourlyData('realTimePrevWeekTrendData', false, isMetricKit, isAexit)));
      return Promise.all(promises);
      // }
    } else {
      // 几天的，获取每天的数据
      let type = '';
      if (trend) {
        type = 'trendData';
      } else if (compare) {
        type = 'compareData';
      }
      return dispatch(getTrendData(type, isMetricKit, isAexit));
    }
  };
}

/**
 * @param params {{ trend: boolean, compare: boolean, prevDay: boolean, prevWeek: boolean, isMetricKit: boolean }}
 */
export function getTrendOrCompareDataAppend(params) {
  let {
    trend = false,
    compare = false,
    prevDay,
    prevWeek,
    isMetricKit = false,
    isAexit = false,
  } = params || {};

  return (dispatch, getState) => {
    if (isNullish(prevDay)) {
      prevDay = getState().summary.get('searchParams').get('enableRealtimePrevDayTrend');
    }
    if (isNullish(prevWeek)) {
      prevWeek = getState().summary.get('searchParams').get('enableRealtimePrevWeekTrend');
    }

    const promises = [];
    trend && promises.push(dispatch(getRealTimeHourlyData('realTimeTrendData', true, isMetricKit, isAexit)));
    compare && promises.push(dispatch(getRealTimeHourlyData('realTimeCompareData', true, isMetricKit, isAexit)));
    prevDay && promises.push(dispatch(getRealTimeHourlyData('realTimePrevDayTrendData', true, isMetricKit, isAexit)));
    prevWeek && promises.push(dispatch(getRealTimeHourlyData('realTimePrevWeekTrendData', true, isMetricKit, isAexit)));
    return Promise.all(promises);
  };
}

/**
 * 获取趋势数据
 * @param dataType 'trendData' 或 'compareData'
 * @param isMetricKit 是否查询 MetricKit 聚合表数据
 */
function getTrendData(dataType, isMetricKit = false, isAexit = false) {
  return (dispatch, getState) => {
    const { appId, pid: platformId } = getState().app.get('current').toJS();
    const isRegionalDashboard = ProductSummaryUtil.getIsRegionalDashboard(platformId);
    const countryGroupConfigList = getState().summary.get('countryGroupConfigList').toJS();
    const {
      trendVersion, startDate1, endDate1, date1, startDate2, endDate2, date2, compareVersion,
      trendCountry, compareCountry,
      vmSelectValue,
      trendUserSceneTag,
      trendRamGib,
      isIntegratedAppTrend,
      integratedAppId,
      subModuleId,
      isQueryVital,
    } = getState().summary.get('searchParams').toJS();

    const { pageType } = getState().summary.get('selectOptions').toJS();
    const vmTypeList = CsvUtil.singleLineParse(vmSelectValue).filter(x => x.trim()).map(x => Number(x));
    let type = PAGE_TYPE_CONVERT[pageType];
    // 退出信息页不适用 vital（崩溃+ANR 合集）：后端按 isAexit 切到 result_aexit_* 后会取 vital_num，
    // 把 AEXIT ANR 算进崩溃趋势。isAexit 时保持 crash，由 aexit 标志决定查哪张表。
    if (isQueryVital && !isAexit && ExceptionCategoryUtil.isCrash(type)) {
      type = PAGE_TYPE_CONVERT.vital;
    }
    const isTrend = dataType === 'trendData';

    const { startDate, endDate } = isTrend
      ? getStartEndDateFromStr(date1, startDate1, endDate1)
      : getStartEndDateFromStr(date2, startDate2, endDate2);

    const usedCountry = isTrend ? trendCountry : compareCountry;
    const countryList = isRegionalDashboard
      ? CountryUtil.queryStringToList(usedCountry)
      : [];
    const needCountryDimension = isRegionalDashboard && countryList.length > 0;

    const userSceneTagList = (trendUserSceneTag || '').split(',').filter(x => x);
    const needUserSceneTagDimension = userSceneTagList.length > 0;

    // RAM 过滤条件目前仅 iOS OOM 趋势图使用，取数时判断条件要跟 SummaryOptions 的展示条件（enableRamGibFilter）完全一致，
    // 避免用户切走之后 URL 里残留的 trendRamGib 在界面不可见的情况下仍然暗中过滤其它异常大类/平台的趋势。
    // 额外排除 isMetricKit：MetricKit 聚合表（result_metric_*）不支持 ram_gib 列，MetricKitPage 复用本 action 时
    // 即使切到 OOM tab（同样是 iOS）也绝不能带上 ramGibList，否则会导致 ClickHouse 报未知列错误。
    const enableRamGibFilter = !isMetricKit && isIos(platformId) && ExceptionCategoryUtil.isOom(pageType);
    const ramGibList = enableRamGibFilter ? (trendRamGib || '').split(',').filter(x => x).map(Number) : [];

    const versionList = isTrend
      ? VersionUtil.makeVersionListFromVersionCsvString(trendVersion)
      : VersionUtil.makeVersionListFromVersionCsvString(compareVersion);
    const isMultiVersion = VersionUtil.isMultipleVersions(versionList);

    return dispatch({
      rest: SummaryRest.trend.getTrend,
      data: {
        appId: isIntegratedAppTrend && integratedAppId
          ? appId + ':' + integratedAppId
          : appId,
        platformId,
        type,
        dataType,
        vmTypeList,
        mergeVmTypes: true,
        ...(subModuleId && { subModuleId }),
        startDate,
        endDate,
        mergeMultipleVersionsWithInaccurateResult: isMultiVersion,
        version: isMultiVersion ? undefined : versionList[0],
        versionList: isMultiVersion ? versionList : undefined,
        needCountryDimension,
        countryList,
        needUserSceneTagDimension,
        ...(needUserSceneTagDimension ? { userSceneTagList } : {}),
        mergeUserSceneTags: true,
        ...(ramGibList.length > 0 ? { ramGibList } : {}),
        // JSON key 用 metricKit（Lombok+Jackson 命名约定）。详见 CrashTrendRequestBean.metricKit 字段注释。
        metricKit: isMetricKit,
        aexit: isAexit,
      },
    });
  };
}

// 小时级数据（分小时 或 累计）
// @param isMetricKit 是否查询 MetricKit 聚合表数据
function getRealTimeHourlyData(dataType, isAppend, isMetricKit = false, isAexit = false) {
  return (dispatch, getState) => {
    const { app, summary } = getState();
    const { appId, pid: platformId } = app.get('current').toJS();
    const isRegionalDashboard = ProductSummaryUtil.getIsRegionalDashboard(platformId);
    const countryGroupConfigList = getState().summary.get('countryGroupConfigList').toJS();
    const {
      trendVersion, compareVersion, startDate1, endDate1, startDate2, endDate2, date1, date2,
      trendCountry, compareCountry,
      vmSelectValue,
      trendUserSceneTag,
      trendRamGib,
      isIntegratedAppTrend,
      integratedAppId,
      subModuleId,
      isQueryVital,
    } = summary.get('searchParams').toJS();
    const { pageType } = summary.get('selectOptions').toJS();
    const vmTypeList = VmTypeUtil.vmSelectValueToVmTypeList(vmSelectValue);
    let type = PAGE_TYPE_CONVERT[pageType];
    // 见 getTrendData 同名注释：退出信息页不走 vital，否则小时趋势会取 result_aexit_hourly 的 vital_num。
    if (isQueryVital && !isAexit && ExceptionCategoryUtil.isCrash(type)) {
      type = PAGE_TYPE_CONVERT.vital;
    }

    const isTrend = dataType !== 'realTimeCompareData';

    const usedCountry = isTrend ? trendCountry : compareCountry;
    const countryList = isRegionalDashboard
      ? CountryUtil.queryStringToList(usedCountry)
      : [];
    const needCountryDimension = isRegionalDashboard && countryList.length > 0;

    const userSceneTagList = (trendUserSceneTag || '').split(',').filter(x => x);
    const needUserSceneTagDimension = userSceneTagList.length > 0;

    // RAM 过滤条件目前仅 iOS OOM 趋势图使用，取数时判断条件要跟 SummaryOptions 的展示条件（enableRamGibFilter）完全一致，
    // 避免用户切走之后 URL 里残留的 trendRamGib 在界面不可见的情况下仍然暗中过滤其它异常大类/平台的趋势。
    // 额外排除 isMetricKit：MetricKit 聚合表（result_metric_*）不支持 ram_gib 列，MetricKitPage 复用本 action 时
    // 即使切到 OOM tab（同样是 iOS）也绝不能带上 ramGibList，否则会导致 ClickHouse 报未知列错误。
    const enableRamGibFilter = !isMetricKit && isIos(platformId) && ExceptionCategoryUtil.isOom(pageType);
    const ramGibList = enableRamGibFilter ? (trendRamGib || '').split(',').filter(x => x).map(Number) : [];

    let { startDate, endDate } = isTrend
      ? getStartEndDateFromStr(date1, startDate1, endDate1)
      : getStartEndDateFromStr(date2, startDate2, endDate2);
    if (dataType === 'realTimePrevDayTrendData') {
      startDate = moment(startDate).subtract(1, 'days').format('YYYYMMDD');
      endDate = moment(endDate).subtract(1, 'days').format('YYYYMMDD');
    } else if (dataType === 'realTimePrevWeekTrendData') {
      startDate = moment(startDate).subtract(7, 'days').format('YYYYMMDD');
      endDate = moment(endDate).subtract(7, 'days').format('YYYYMMDD');
    }

    const versionList = isTrend
      ? VersionUtil.makeVersionListFromVersionCsvString(trendVersion)
      : VersionUtil.makeVersionListFromVersionCsvString(compareVersion);
    const isMultiVersion = VersionUtil.isMultipleVersions(versionList);
    const serverAppSettings = app.get('appIdToServerAppSettings')?.[appId] || {};
    const enableTenMinuteTrend = !!serverAppSettings[ServerAppSettings.keys.enableTenMinuteTrend];
    const effectiveGranularity = summary.getIn(['searchParams', 'realTimeGranularity']) || (enableTenMinuteTrend ? '10m' : '1h');
    const isTenMin = !isMetricKit && !isAexit && enableTenMinuteTrend && effectiveGranularity === '10m';

    return dispatch({
      rest: isAppend ? SummaryRest.realTime.getAppendMinutelyStat : SummaryRest.realTime.getHourlyStat,
      data: {
        appId: isIntegratedAppTrend && integratedAppId
          ? appId + ':' + integratedAppId
          : appId,
        platformId,
        type,
        vmTypeList,
        mergeVmTypes: true,
        dataType,
        ...(subModuleId && { subModuleId }),
        mergeMultipleVersionsWithInaccurateResult: isMultiVersion,
        version: isMultiVersion ? undefined : versionList[0],
        versionList: isMultiVersion ? versionList : undefined,
        startDate: `${startDate}00`,
        endDate: `${endDate}23`,
        needCountryDimension,
        countryList,
        needUserSceneTagDimension,
        ...(needUserSceneTagDimension ? { userSceneTagList } : {}),
        mergeUserSceneTags: true,
        ...(ramGibList.length > 0 ? { ramGibList } : {}),
        // JSON key 用 metricKit（Lombok+Jackson 命名约定）。详见 CrashTrendRequestBean.metricKit 字段注释。
        metricKit: isMetricKit,
        aexit: isAexit,
        ...(isTenMin ? { tenMin: true } : {}),
      },
    });
  };
}

/**
 * 获取排行榜数据
 */

function getTopData(rest, mode, field) {
  const sortByException = !mode.includes('access');
  return () => {
    return (dispatch, getState) => {
      const { app, summary } = getState();
      const { appId, pid } = app.get('current').toJS();
      const {
        rankVersion,
        startDate3,
        rankMaxDate,
        rankCountry,
        rankVmSelectValue,
        isQueryVital,
      } = summary.get('searchParams').toJS();
      const { pageType } = getState().summary.get('selectOptions').toJS();
      let type = PAGE_TYPE_CONVERT[pageType];
      if (isQueryVital && ExceptionCategoryUtil.isCrash(type)) {
        type = PAGE_TYPE_CONVERT.vital;
      }
      const sortField = ExceptionCategoryUtil.isJank(type) ? 'REPORT_COUNT' : undefined; // 王者卡顿，按次数排序

      const versionList = VersionUtil.makeVersionListFromVersionCsvString(rankVersion);
      const isMultiVersion = VersionUtil.isMultipleVersions(versionList);

      const minDate = startDate3;
      const maxDate = rankMaxDate || startDate3;

      const body =  {
        appId,
        pid,
        platformId: pid,
        mergeMultipleVersionsWithInaccurateResult: isMultiVersion,
        version: isMultiVersion ? undefined : versionList[0],
        versionList: isMultiVersion ? versionList : undefined,
        minDate,
        maxDate,
        mergeMultipleDatesWithInaccurateResult: minDate !== maxDate,
        type,
        limit: 5,
        field,
        sortByException,
        sortField, // 王者卡顿，按次数排序
        countryList: CountryUtil.queryStringToList(rankCountry),
        vmTypeList: VmTypeUtil.vmSelectValueToVmTypeList(rankVmSelectValue),
        needQueryFieldRollup: true,
      };
      sessionStorage.setItem(mode,JSON.stringify(body));
      return dispatch({
        rest,
        data: body,
      });
    };
  };
}
